import { Breakpoints } from "../../breakpoints";

class RevealCard extends HTMLElement {
  constructor() {
    super();
    // document.addEventListener("DOMContentLoaded", () => {
      this.init();
    // });
  }

  init() {
    const el = 'reveal-card';
    const image = this.querySelector(`.${el}__image img`);
    const copy = this.querySelector(`.${el}__copy`);
    const copyInner = this.querySelector(`.${el}__copy-inner`);

    // Function to check if reveal functionality should be active
    const revealQuery = window.matchMedia(`(min-width: ${Breakpoints.md}px)`);
    const shouldReveal = () => revealQuery.matches;

    this.addEventListener('mouseenter', (e) => {
      // On mobile and medium screens, everything is displayed by default.
      if (!shouldReveal()) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const copyHeight = copyInner.clientHeight;

      // Shift the image and reveal the text on larger screens
      image.style.marginTop = `-${copyHeight/2}px`;
      image.style.marginBottom = `-${copyHeight/2}px`;
      copy.style.height = `${copyHeight}px`
    });
    this.addEventListener('mouseleave', (e) => {
      // On mobile and medium screens, everything is displayed by default.
      if (!shouldReveal()) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      image.style.marginTop = null;
      image.style.marginBottom = null;
      copy.style.height = null;
    });
  }
}

if (!customElements.get('reveal-card')) {
  customElements.define('reveal-card', RevealCard);
}
